export default __webpack_public_path__ + "static/media/p6.077ed2ee.jpg";